import { useGet as useGetPublicHcd } from '@maiia/model/generated/model/api-patient/hooks/patPublicHcd';
import { useGet as useGetHcd } from '@maiia/model/generated/model/api-patient/hooks/patHcd';
import { useCurrentUser } from '@docavenue/components';
import { ENTIRE_FRANCE_DISTANCE_MAX } from '@/src/constants';
import { HcdFilters } from '@/src/types/filters';
import { LIMITATION_ALL_PATIENTS } from '@/components/molecules/FilterBar/TLCPatientLimitationSwitch';

const useUpcomingTLCs = (filters: Record<string, any>) => {
  const currentUser = useCurrentUser();
  const isDemo = !!currentUser?.userPatientInformation?.isDemo;

  const hcdFilters: HcdFilters = {
    consultationModeFilter: 'TLC',
    'availabilityFilter.type': 'TODAY',
    newPatientFilter: filters.newPatientFilter || LIMITATION_ALL_PATIENTS,
    limit: 5,
    size: 5,
    distanceMax: ENTIRE_FRANCE_DISTANCE_MAX,
    'speciality.shortName': filters.speciality,
    extraFeeFilter: filters.extraFeeFilter,
  };

  const { data: hcd } = useGetHcd(hcdFilters, { enabled: isDemo });
  const { data: publicHcd } = useGetPublicHcd(hcdFilters, { enabled: !isDemo });

  const data = isDemo ? hcd : publicHcd;

  return data?.items ?? [];
};

export default useUpcomingTLCs;
